import {
    FETCH_DELETE_WASTE_BY_ID_REQUEST,
    FETCH_DELETE_WASTE_BY_ID_SUCCESS,
    FETCH_DELETE_WASTE_BY_ID_FALUIRE,
} from './deleteWasteByIDType'

const initialState = {
    loading: false,
    isDeleteWasteSuccess: null,
    error: '',
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DELETE_WASTE_BY_ID_REQUEST: return {
            ...state,
            loading: true,

        }

        case FETCH_DELETE_WASTE_BY_ID_SUCCESS: return {
            ...state,
            isDeleteWasteSuccess: action.payload,
            error: '',
            loading: false,
        }

        case FETCH_DELETE_WASTE_BY_ID_FALUIRE: return {
            ...state,
            loading: false,
            isDeleteWasteSuccess: null,
            error: action.payload,
        }
        default: return state
    }
}

export default reducer
